const components = {}

/**
* Will scope the components script to the DOM element of the component.
*
* @param {string} name The name of the component
* @param {element} component The component DOM element
*/
const register = (name, component) => {
  components[name] = component
  document.addEventListener('DOMContentLoaded', () => {
    apply(name)
  })
}

const apply = (name, scope = document) => {
  scope.querySelectorAll(`[data-component=${name}]`).forEach(el => components[name](el))
}
export {
  register
}
